var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:['checkbox', _vm.labelSize]},[_c('input',{ref:"input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.onInput}}),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }